import {Target, Sprout, Brain, Medal, Leaf, Book, Zap, Flame, Mountain, Rocket } from 'lucide-react';

export const coursesData = [
  // CLASS VI
  {
    id: 1,
    name: 'Stone Foundation Program',
    class: 'Class VI',
    target: 'Foundation | Olympiad',
    description: 'One year foundation program to build strong academic and competitive fundamentals.',
    duration: '1 Year',
    features: [
      'Concept clarity from basics',
      'Logical thinking development',
      'Olympiad exposure',
      'Regular assessments'
    ],
    icon: <Target className="h-12 w-12 text-warning m-auto" />
  },

  // CLASS VII
  {
    id: 2,
    name: 'Root Foundation Program',
    class: 'Class VII',
    target: 'Foundation | Olympiad',
    description: 'Two year foundation program designed to strengthen core concepts.',
    duration: '2 Years',
    features: [
      'Advanced foundation building',
      'Problem solving approach',
      'Stage-wise testing',
      'Expert mentoring'
    ],
    icon: <Sprout className="h-12 w-12 text-secondary m-auto" />
  },

  // CLASS VIII
  {
    id: 3,
    name: 'Root Foundation Program',
    class: 'Class VIII',
    target: 'Foundation | Olympiad',
    description: 'One year foundation program focusing on competitive readiness.',
    duration: '1 Year',
    features: [
      'Strong concept reinforcement',
      'Olympiad preparation',
      'Regular tests',
      'Personal attention'
    ],
    icon: <Leaf className="h-12 w-12 text-success m-auto" />
  },

  // CLASS IX – BRAINY
  {
    id: 4,
    name: 'Brainy Program',
    class: 'Class IX',
    target: 'IIT-JEE | NEET | Olympiad',
    description: 'Four year integrated program for early competitive exam preparation.',
    duration: '4 Years',
    features: [
      'Board + competitive syllabus',
      'Deep conceptual clarity',
      'Regular mock tests',
      'Performance tracking'
    ],
    icon: <Brain className="h-12 w-12 text-primary m-auto" />
  },

  // CLASS IX – CORE OLYMPIAD
  {
    id: 5,
    name: 'Core Olympiad Program',
    class: 'Class IX',
    target: 'Olympiad Stage 1 & 2',
    description: 'Two year focused Olympiad preparation program.',
    duration: '2 Years',
    features: [
      'Olympiad-specific concepts',
      'Advanced problem solving',
      'Stage-wise testing',
      'Expert guidance'
    ],
    icon: <Medal className="h-12 w-12 text-info m-auto" />
  },

  // CLASS IX – CBSE
  {
    id: 6,
    name: 'CBSE Classroom Program',
    class: 'Class IX',
    target: 'CBSE Board',
    description: 'One year CBSE classroom program for academic excellence.',
    duration: '1 Year',
    features: [
      'NCERT focused teaching',
      'Board exam preparation',
      'Regular tests',
      'Doubt clearing sessions'
    ],
    icon: <Book className="h-12 w-12 text-secondary m-auto" />
  },

  // CLASS X – CLEVER
  {
    id: 7,
    name: 'Clever Program',
    class: 'Class X',
    target: 'IIT-JEE | NEET | Olympiad',
    description: 'Three year program integrating board and competitive preparation.',
    duration: '3 Years',
    features: [
      'Board + entrance preparation',
      'Advanced practice',
      'National test series',
      'Expert faculty support'
    ],
    icon: <Zap className="h-12 w-12 text-warning m-auto" />
  },

  // CLASS X – CORE OLYMPIAD
  {
    id: 8,
    name: 'Core Olympiad Program',
    class: 'Class X',
    target: 'Olympiad Stage 1 & 2',
    description: 'One year intensive Olympiad preparation program.',
    duration: '1 Year',
    features: [
      'High-level Olympiad problems',
      'Concept mastery',
      'Mock Olympiad tests',
      'Personal mentoring'
    ],
    icon: <Medal className="h-12 w-12 text-success m-auto" />
  },

  // CLASS X – CBSE
  {
    id: 9,
    name: 'CBSE Classroom Program',
    class: 'Class X',
    target: 'CBSE Board',
    description: 'One year CBSE focused classroom coaching.',
    duration: '1 Year',
    features: [
      'NCERT based teaching',
      'Board exam strategy',
      'Regular assessments',
      'Doubt sessions'
    ],
    icon: <Book className="h-12 w-12 text-info m-auto" />
  },

  // CLASS XI – SPARK
  {
    id: 10,
    name: 'Spark Classroom Program',
    class: 'Class XI',
    target: 'IIT-JEE | NEET | Olympiad',
    description: 'Two year classroom program for serious competitive aspirants.',
    duration: '2 Years',
    features: [
      'Complete syllabus coverage',
      'Concept-driven learning',
      'Regular testing',
      'Performance analysis'
    ],
    icon: <Flame className="h-12 w-12 text-secondary m-auto" />
  },

  // CLASS XI – CBSE
  {
    id: 11,
    name: 'CBSE Classroom Program',
    class: 'Class XI',
    target: 'CBSE Board',
    description: 'One year CBSE classroom program.',
    duration: '1 Year',
    features: [
      'Board focused teaching',
      'NCERT based preparation',
      'Regular tests',
      'Doubt resolution'
    ],
    icon: <Book className="h-12 w-12 text-warning m-auto" />
  },

  // CLASS XII – PINNACLE
  {
    id: 12,
    name: 'Pinnacle Classroom Program',
    class: 'Class XII',
    target: 'IIT-JEE | NEET | Olympiad',
    description: 'One year intensive classroom program for Class XII.',
    duration: '1 Year',
    features: [
      'Revision & practice',
      'Exam strategy building',
      'Previous year papers',
      'Time management'
    ],
    icon: <Mountain className="h-12 w-12 text-primary m-auto" />
  },

  // CLASS XII – CBSE
  {
    id: 13,
    name: 'CBSE Classroom Program',
    class: 'Class XII',
    target: 'CBSE Board',
    description: 'One year CBSE focused academic program.',
    duration: '1 Year',
    features: [
      'Board exam preparation',
      'Concept reinforcement',
      'Regular assessments',
      'Doubt sessions'
    ],
    icon: <Book className="h-12 w-12 text-success m-auto" />
  },

  // CLASS XII PASS – BRISK
  {
    id: 14,
    name: 'Brisk Dropper Program',
    class: 'XII Pass',
    target: 'IIT-JEE | NEET | Olympiad',
    description: 'One year intensive dropper program targeting top ranks.',
    duration: '1 Year',
    features: [
      'Complete syllabus revision',
      'Intensive test series',
      'Personal mentoring',
      'Result oriented approach'
    ],
    icon: <Rocket className="h-12 w-12 text-secondary m-auto" />
  }
];

export const courseCategories = [
  {
    id: 1,
    name: 'Foundation Programs',
    classes: 'VI to VIII',
    icon: '📘'
  },
  {
    id: 2,
    name: 'Pre-Foundation',
    classes: 'IX to X',
    icon: '🧠'
  },
  {
    id: 3,
    name: 'JEE Programs',
    classes: 'XI to XII',
    icon: '⚡'
  },
  {
    id: 4,
    name: 'NEET Programs',
    classes: 'XI to XII',
    icon: '⚕️'
  },
  {
    id: 5,
    name: 'Dropper Batch',
    classes: 'XII Pass',
    icon: '🚀'
  }
];